const removeLocalBuilderData = ({localStorageId}) => {
  localStorage.removeItem(localStorageId);  
  localStorage.removeItem(`${localStorageId}_updated_at`);
  localStorage.removeItem(`${localStorageId}_pies`);
  localStorage.removeItem(`${localStorageId}_pies_updated_at`);
  localStorage.removeItem(`${localStorageId}_pies_server_copy_updated_at`);  
}

export default removeLocalBuilderData